/**
 * How far down the page the reader is.
 *
 * Hidden outright under reduced motion. A progress bar that cannot move is not a
 * quieter progress bar — it is a bar asserting a position that is false the
 * moment the reader scrolls. Better absent than lying.
 *
 * `scroll-timeline` would do this without JavaScript, but it is not in Safari,
 * and this is a two-line effect.
 */
import { useEffect, useState } from 'react'

import { useReducedMotionSafe } from './motion'

export function ScrollProgress() {
  const reduced = useReducedMotionSafe()
  const [pct, setPct] = useState(0)

  useEffect(() => {
    if (reduced) return
    const read = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight
      setPct(max > 0 ? (window.scrollY / max) * 100 : 0)
    }
    read()
    window.addEventListener('scroll', read, { passive: true })
    window.addEventListener('resize', read)
    return () => {
      window.removeEventListener('scroll', read)
      window.removeEventListener('resize', read)
    }
  }, [reduced])

  if (reduced) return null

  return <div className="kl-scrollprogress" style={{ transform: `scaleX(${pct / 100})` }} aria-hidden="true" />
}
